module.exports = __webpack_public_path__ + "media/images/core_values/fitness-a0cd47854129f50e7465999fdb6ae68d.png";